import { gqlClient } from "../configs/api-config";
import store, { persistor } from "../configs/store-config";
import globalActions from "../ducks/global/actions";
import userSelectors from "../ducks/user/selectors";
import { gql } from "graphql-request";

function requestHelper(query, variables?: {}, headers?: {}) {
  return gqlClient
    .request(
      gql`
        ${query}
      `,
      variables,
      headers
    )
    .catch((error) => {
      if (error.response?.errors[0].extensions.code === "UNAUTHENTICATED") {
        let hasToken = userSelectors.getToken(store.getState());
        if (hasToken) {
          store.dispatch(globalActions.logout());
          persistor.flush();
        }
      }
      return Promise.reject(error);
    });
}

export { requestHelper };
